"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adapter_1 = require("../core/adapter");
var RuntimeDataSourceItem_1 = require("../core/RuntimeDataSourceItem");
var reloadDataSourceFactory_1 = require("../core/reloadDataSourceFactory");
var helpers_1 = require("../helpers");
/**
 * @param dataSource
 * @param context
 * @param extraConfig: { requestHandlersMap }
 */
exports.default = (function (dataSource, context, extraConfig) {
    if (extraConfig === void 0) { extraConfig = { requestHandlersMap: {} }; }
    var requestHandlersMap = extraConfig.requestHandlersMap;
    var runtimeDataSource = (0, adapter_1.adapt2Runtime)(dataSource, context, {
        defaultDataHandler: extraConfig.defaultDataHandler,
    });
    var dataSourceMap = runtimeDataSource.list.reduce(function (prev, current) {
        prev[current.id] = new RuntimeDataSourceItem_1.RuntimeDataSourceItem(current, (0, helpers_1.getRequestHandler)(current, requestHandlersMap), context);
        return prev;
    }, {});
    return {
        dataSourceMap: dataSourceMap,
        reloadDataSource: (0, reloadDataSourceFactory_1.reloadDataSourceFactory)(runtimeDataSource, dataSourceMap, runtimeDataSource.dataHandler),
    };
});
